import {Outlet} from 'react-router-dom'
import {HeaderWrapper} from './components/header'
import {ScrollTop} from './components/scroll-top'
import {Content} from './components/content'
import {FooterWrapper} from './components/footer'
import {Sidebar} from './components/sidebar'
import {PageDataProvider} from './core'
import {ToolbarWrapper} from './components/toolbar'
import {LocationMenuReinit} from './LocationMenuReinit'

// The shell does not subscribe to the router itself (ADR-0022): the menu
// re-initialisation lives in `LocationMenuReinit`, keyed on the pathname.
const MasterLayout = () => {
  return (
    <PageDataProvider>
      <LocationMenuReinit />
      <div className='d-flex flex-column flex-root app-root' id='kt_app_root'>
        <div className='app-page flex-column flex-column-fluid' id='kt_app_page'>
          <HeaderWrapper />
          <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
            <Sidebar />
            <div className='app-main flex-column flex-row-fluid' id='kt_app_main'>
              <div className='d-flex flex-column flex-column-fluid'>
                <ToolbarWrapper />
                <Content>
                  <Outlet />
                </Content>
              </div>
              <FooterWrapper />
            </div>
          </div>
        </div>
      </div>

      {/* begin:: Drawers */}

      {/* <ActivityDrawer /> */}
      {/* <DrawerMessenger /> */}

      {/* end:: Drawers */}

      {/* begin:: Modals */}
      {/* end:: Modals */}
      <ScrollTop />
    </PageDataProvider>
  )
}

export {MasterLayout}
